module.exports = __webpack_public_path__ + "static/media/A18040103_10004_0.68650a91.jpg";